import React from 'react';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

const LocationSection = ({ formData, handleChange, inputCls, renderFieldError }) => (
  <div className="border border-[#E5E5E5] rounded-lg p-4 space-y-3 bg-[#FAFAFA]">
    <p className="text-sm font-semibold text-[#0A0A0A]">Ubicación</p>
    <div>
      <Label className="text-[#0A0A0A]">Nombre del salón / teatro <span className="text-xs text-[#737373]">(opcional)</span></Label>
      <Input value={formData.venue_name} onChange={(e) => handleChange('venue_name', e.target.value)} placeholder="Ej: Teatro Municipal de Salta" className={inputCls('venue_name')} data-testid="venue-input" />
    </div>
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
      <div>
        <Label className="text-[#0A0A0A]">Dirección {formData.modality !== 'virtual' && '*'}</Label>
        <Input value={formData.address} onChange={(e) => handleChange('address', e.target.value)} placeholder="Zuviría 70" className={inputCls('address')} data-testid="address-input" />
        {renderFieldError("address")}
      </div>
      <div>
        <Label className="text-[#0A0A0A]">Ciudad</Label>
        <Input value={formData.city} onChange={(e) => handleChange('city', e.target.value)} className={inputCls('city')} data-testid="city-input" />
      </div>
    </div>
    <p className="text-xs text-[#737373]">💡 La ubicación se mostrará automáticamente en Google Maps una vez publicado el evento.</p>
  </div>
);

export default LocationSection;
